module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar",
    attrs: {
      "id": "sidebar"
    }
  }, [_c('div', {
    attrs: {
      "data-scrollbar": "true",
      "data-height": "100%"
    }
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-header"
  }, [_vm._v("Navigation")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/",
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-tachometer"
  }), _c('span', [_vm._v("Dashboard")])])]), _vm._v(" "), (_vm.$store.state.auth.scopes.includes('admin_userman')) ? _c('usman-nav') : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.scopes.includes('admin_itembank')) ? _c('sbmptn-nav') : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.scopes.includes('admin_itembank')) ? _c('tryoutgroup-nav') : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.scopes.includes('admin_userman')) ? _c('organizations-nav') : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.scopes.includes('admin_sales')) ? _c('affiliate-nav') : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.scopes.includes('admin_itembank')) ? _c('itembank-nav') : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.scopes.includes('admin_itembank')) ? _c('kodifikasi-nav') : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.scopes.includes('admin_modul_belajar')) ? _c('modulbelajar-nav') : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.scopes.includes('admin_userman')) ? _c('teacher-nav') : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.scopes.includes('admin_itembank')) ? _c('duel-nav') : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.scopes.includes('admin_sales')) ? _c('pembayaran-nav') : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.scopes.includes('admin_sales')) ? _c('voucher-nav') : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.scopes.includes('admin_itembank')) ? _c('video-nav') : _vm._e(), _vm._v(" "), _c('pushnotif-nav'), _vm._v(" "), (_vm.$store.state.auth.scopes.includes('admin_itembank')) ? _c('bimbel-nav') : _vm._e(), _vm._v(" "), _c('content-nav'), _vm._v(" "), _vm._m(0)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "sidebar-minify-btn",
    attrs: {
      "href": "javascript:;",
      "data-click": "sidebar-minify"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-216cc9a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Sidebar.vue
// module id = 1304
// module chunks = 0